import React from 'react';
import PropTypes from 'prop-types';
import { Flex } from 'onefaceui-react-components';
import { getResourceTo } from 'react/utils/utils';
import { FILTER_EQUIPMENT_VISIBILITY_OPTIONS } from '../constants';

const { SHOW_ALL, ACTIVE_LAST_7_DAYS } = FILTER_EQUIPMENT_VISIBILITY_OPTIONS;

function FilterEquipmentVisibilityPopoverContent({
  defaultChecked,
  onOptionChange
}) {
  return (
    <Flex direction="column" gap={8}>
      <div>
        <span style={{ marginRight: 12 }}>
          {getResourceTo('FilterEquipmentVisibility.title')}
        </span>
      </div>
      <div>
        <label style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
          <input
            data-testid="filterEquipmentsTooltipOptionShowAll"
            type="radio"
            name="equipment-visibility"
            value={SHOW_ALL}
            checked={defaultChecked === SHOW_ALL}
            onChange={onOptionChange}
          />
          <span>{getResourceTo('FilterEquipmentVisibility.option.showAll')}</span>
        </label>
        <label style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
          <input
            data-testid="filterEquipmentsTooltipOptionActiveLast7Days"
            type="radio"
            name="equipment-visibility"
            value={ACTIVE_LAST_7_DAYS}
            checked={defaultChecked === ACTIVE_LAST_7_DAYS}
            onChange={onOptionChange}
          />
          <span>{getResourceTo('FilterEquipmentVisibility.option.activeLast7Days')}</span>
        </label>
      </div>
    </Flex>
  );
}

FilterEquipmentVisibilityPopoverContent.propTypes = {
  defaultChecked: PropTypes.string.isRequired,
  onOptionChange: PropTypes.func.isRequired
};

export default FilterEquipmentVisibilityPopoverContent;
